import { CardContent, Grid, Paper, Typography } from '@material-ui/core';
import React from 'react';
import { CheckBoxFastField, TextFieldFastField } from '../../../components';
import useStyles from './sampleDevelopmentNl.style';

interface SampleDevelopmentNlJobTypeProps {
  isCrtLocked?: boolean;
}

const SampleDevelopmentNlJobType: React.FC<SampleDevelopmentNlJobTypeProps> = (props) => {
  const { isCrtLocked = false } = props;
  const classes = useStyles();

  return (
    <CardContent>
      <Paper variant="outlined">
        <Typography className={classes.title}>Type งาน</Typography>
        <CardContent>
          <Grid
            container
            spacing={1}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid container item xs={12} spacing={1}>
              <Grid item xs={12} md={2}>
                <Typography className={classes.numberTitle} display="inline">
                  1.
                </Typography>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="prodInfoSticker"
                  label="Sticker"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="prodInfoFilm"
                  label="Film"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="prodInfoPaper"
                  label="Paper"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="prodInfoFabric"
                  label="Fabric"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="prodInfoOther"
                  label="Others"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextFieldFastField
                  disabled={isCrtLocked}
                  className={classes.textInputRightCheckbox}
                  name="prodInfoOtherData"
                  label="Others"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                />
              </Grid>
            </Grid>

            <Grid container item xs={12} spacing={1}>
              <Grid item xs={12} md={2}>
                <Typography className={classes.numberTitle} display="inline">
                  2.
                </Typography>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="prodInfoFlexo"
                  label="Flexo"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="prodInfoDigital"
                  label="Digital"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="prodInfoOffset"
                  label="Offset"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="prodInfoSilkscreen"
                  label="Silkscreen"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="prodInfoGravure"
                  label="Gravure"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="prodInfoColdStamping"
                  label="Cold Stamping"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="prodInfoHotStamping"
                  label="Hot Stamping"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="prodInfoLetterPress"
                  label="Letter Press (Labelman)"
                />
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Paper>
    </CardContent>
  );
};

export default SampleDevelopmentNlJobType;
